import React from 'react';

import { Badge, Stack } from '@eluve/components';

export interface WorkflowMatrixDetailsProps {
  modelPromptTemplatesCount: number;
  totalFacts: number;
  totalArtifacts: number;
}

export const WorkflowMatrixDetails: React.FC<WorkflowMatrixDetailsProps> = ({
  modelPromptTemplatesCount,
  totalArtifacts,
  totalFacts,
}) => {
  return (
    <Stack direction="horizontal" align="center" gap={2}>
      <Badge variant="info">{modelPromptTemplatesCount} target configs</Badge>
      <span>X</span>
      <Badge variant="info">{totalArtifacts} artifacts</Badge>
      <span className="text-text-primary">{` = ${totalArtifacts * modelPromptTemplatesCount} total inputs and ${totalFacts * modelPromptTemplatesCount} total facts`}</span>
    </Stack>
  );
};
